import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import cmsPagesService from "./cmsPagesService";

export const getPages = createAsyncThunk(
  "cmsPages/get-pages",
  async (params, thunkAPI) => {
    try {
      return await cmsPagesService.getPages(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createPage = createAsyncThunk(
  "cmsPages/create-page",
  async (pageData, thunkAPI) => {
    try {
      return await cmsPagesService.createPage(pageData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAPage = createAsyncThunk(
  "cmsPages/get-a-page",
  async (id, thunkAPI) => {
    try {
      return await cmsPagesService.getPage(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAPage = createAsyncThunk(
  "cmsPages/update-page",
  async ({ id, pageData }, thunkAPI) => {
    try {
      return await cmsPagesService.updatePage(id, pageData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAPage = createAsyncThunk(
  "cmsPages/delete-page",
  async (id, thunkAPI) => {
    try {
      return await cmsPagesService.deletePage(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  pages: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const cmsPagesSlice = createSlice({
  name: "cmsPages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPages.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPages.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.pages = action.payload;
      })
      .addCase(getPages.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createPage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdPage = action.payload;
      })
      .addCase(createPage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAPage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.pageTitle = action.payload.title;
        state.pageContent = action.payload.content;
        state.pageMetaTitle = action.payload.metaTitle;
        state.pageMetaDescription = action.payload.metaDescription;
        state.pageMetaKeywords = action.payload.metaKeywords;
        state.pageIsPublished = action.payload.isPublished;
        state.pageOrder = action.payload.order;
        state.pageImages = action.payload.images;
      })
      .addCase(getAPage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAPage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedPage = action.payload;
      })
      .addCase(updateAPage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAPage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedPage = action.payload;
      })
      .addCase(deleteAPage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default cmsPagesSlice.reducer;

